import { useMutation } from '@tanstack/react-query';

import { completeSignup, type CompleteSignupPayload, type CompleteSignupResponse } from '@/api/adapters/signup';
import { ApiError } from '@/api/error';

/**
 * Sign-up completion mutation.
 * Returns the raw useMutation so callers attach their own onSuccess / onError.
 */
export function useSignup(token: string) {
  return useMutation<CompleteSignupResponse, ApiError, CompleteSignupPayload>({
    mutationFn: (payload) => completeSignup(token, payload),
  });
}
